import { Header, Button } from '@amzn/awsui-components-react';
import { Event, Shift, Source } from '@amzn/red-velvet-api';
import { useLocalizedText } from '../../../hooks/localizedText';
import { useSearchParams } from 'react-router-dom';
import { DISPLAY_ATTRIBUTES_TYPE, ShiftInfo } from '../../shifts/shiftInfo';
import { SpaLink } from '../../SpaLink';
import { EditEventLink } from '../../shifts/actions';
import { useUrlPage } from '../../../hooks/attendance/urlPage';
import { FIRST_PAGE } from '../wizard/attendanceWizard';
import { useUser } from '../../../hooks/user';
import { canEditEvent, canManageVCEvent } from '../../../utils/shiftUtils';
import { featureIsEnabled, useFeatures } from '../../../hooks/features';
import { ADMIN_EVENT_PAGE_ACCESS } from '../../../utils/constants';

interface ShiftHeaderProps {
  event: Event;
  manageSignup?: boolean;
}

export function ShiftHeader(props: ShiftHeaderProps) {
  const namespaces = ['attendance', 'translation'];
  const { t } = useLocalizedText(namespaces);
  const users = useUser();

  const { event, manageSignup = false } = props;
  const analyticsPrefix = manageSignup ? 'manageSignup' : 'trackAttendance';
  const [searchParams] = useSearchParams();
  const selectedTimezone = searchParams.get('timezone');
  const urlFeatures = searchParams.get('features');
  const viewDetailsUrl = `/view-event?id=${event.eventId}${selectedTimezone ? '&timezone=' + selectedTimezone : ''}${urlFeatures ? '&features=' + urlFeatures : ''}`;
  const { page, setPage } = useUrlPage(FIRST_PAGE);
  const features = useFeatures();
  const isAdmin = featureIsEnabled(ADMIN_EVENT_PAGE_ACCESS, features, searchParams);

  const isGivehub = event.source === Source.GIVEHUB;

  // Users who can open this page but can't edit the event (e.g. direct-link visitors) get a
  // disabled Edit button with a reason rather than no button at all. Admins can edit GIVEHUB events.
  let headerAction;
  if (isGivehub) {
    headerAction = (
      <EditEventLink
        event={event}
        source="viewEvent"
        disabled={!canEditEvent(event, users, isAdmin)}
      />
    );
  } else if (page > 0) {
    const canEdit = canManageVCEvent(event, users);
    headerAction = (
      <Button
        data-aci-analytics-name={`${analyticsPrefix}_editEvent`}
        disabled={!canEdit}
        disabledReason={canEdit ? undefined : t('eventDetails.shiftDisplay.editNotAllowedReason')}
        onClick={() => setPage(0)}
      >
        {t('attendanceHeader.editEvent')}
      </Button>
    );
  }

  return (
    <Header actions={headerAction}>
      {isGivehub ? (
        <SpaLink data-aci-analytics-name={`${analyticsPrefix}_title`} href={viewDetailsUrl}>
          <h2>{event.title}</h2>
        </SpaLink>
      ) : (
        <h2>{event.title}</h2>
      )}
    </Header>
  );
}
interface ShiftCardProps {
  event: Event;
  shift: Shift;
  displayAttributes: DISPLAY_ATTRIBUTES_TYPE[];
}

export function ShiftCard({ event, shift, displayAttributes }: ShiftCardProps) {
  return <ShiftInfo event={event} shift={shift} displayAttributes={displayAttributes} />;
}
